import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {InsolesProviderModelMaterialModel} from "./insolesProviderModelMaterial.model";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {Injectable} from "@angular/core";
import {InsoleMaterialSummaryConverter} from "../../../../material/api/entity/insoleMaterialSummary.converter";
import {InsolesProviderModelGabaritModel} from "./insolesProviderModelGabarit.model";
import {LovValueConverter} from "../../../../../common/lov/lov-value/api/converter/LovValue.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProviderModelGabaritConverter extends HttpModelConverter<InsolesProviderModelGabaritModel>{

    constructor(private lovValueConverter: LovValueConverter) {
        super();
    }

    protected createInstance(): InsolesProviderModelGabaritModel {
        return new InsolesProviderModelGabaritModel();
    }

    protected enrichObject(result: InsolesProviderModelGabaritModel, src: InsolesProviderModelGabaritModel) {
        result.gabarit = this.lovValueConverter.convert(src.gabarit);
    }

}